import LeaderList from './LeaderList';

export default LeaderList;
